import { useEffect, useState } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Action, Dispatch } from 'redux';

import lang from '../../../lib/language';
import { RootState } from '../../../lib/store';
import { sendResetPassword } from '../../../lib/store/auth';

import { MobileDrawer } from '../../../components';
import Button from '../../../shared_components/Button/Button';
import { ButtonTypesEnum } from '../../../shared_components/Button/Button.types';

import styles from './ChangePasswordModal.module.scss';

type OwnProps = {
  isOpen: boolean;
  onClose: () => void;
};

type Props = OwnProps & ReduxProps;

const ChangePasswordModal = (props: Props) => {
  const {
    isOpen,
    onClose,
    resetPassword,
    individual,
  } = props;
  const [confirmed, setConfirmed] = useState(false);


  // The drawer is rendered by a page that never unmounts, so reset to the first step on open.
  useEffect(() => {
    if (isOpen) {
      setConfirmed(false);
    }
  }, [isOpen]);

  const handleProceed = () => {
    resetPassword();
    setConfirmed(true);
  };

  const content = (
    <div className={styles.buttonsWrapper}>
      <Button fullWidth biggerFontSize onClick={handleProceed}>
        {lang.commonOrderSideButtonProceed()}
      </Button>
      <Button
        variant={ButtonTypesEnum.Secondary}
        fullWidth
        biggerFontSize
        onClick={onClose}
      >
        {lang.commonCancelButton()}
      </Button>
    </div>
  );

  const confirmedContent = (
    <>
      <div className={styles.text}>
        <div>{lang.mobilePasswordChangeEmailUnderlineHeading1()}</div>
        <div className={styles.email}>{individual?.email ?? ''}</div>
        <div>{lang.mobilePasswordChangeEmailUnderlineHeading2()}</div>
      </div>
      <div className={styles.buttonsWrapper}>
        <Button fullWidth biggerFontSize onClick={onClose}>
          {lang.commonOkay()}
        </Button>
      </div>
    </>
  );

  return (
    <MobileDrawer
      title={confirmed ? lang.mobilePasswordChangeEmailTitle() : lang.mobileChangePasswordModalText()}
      isOpen={isOpen}
      onClose={onClose}
    >
      {confirmed ? confirmedContent : content}
    </MobileDrawer>
  );
};

const mapStateToProps = (state: RootState) => ({
  individual: state.crm.individualExtendedInfo,
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  resetPassword: () => dispatch(sendResetPassword({})),
});

const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(ChangePasswordModal);
